// Business Constants
export const FETCH_BUSINESS_REQUEST = "FETCH_BUSINESS_REQUEST";
export const FETCH_BUSINESS_SUCCESS = "FETCH_BUSINESS_SUCCESS";
export const FETCH_BUSINESS_FAIL = "FETCH_BUSINESS_FAIL";
export const CLEAR_BUSINESS_ERRORS = "CLEAR_BUSINESS_ERRORS";
